<template>
  <App v-if="accountStore.account" />
</template>

<script setup lang="ts">
import { useAccountStore } from "@/store/stores/account";

import App from "./App.vue";

const accountStore = useAccountStore();

if (!accountStore.account) {
  window.location.href = `/login?next=${encodeURIComponent(
    window.location.href
  )}`;
}
</script>
